import { API_BASE_URL } from '../../config/config';
import { NotesClient, NotesDTO } from '../../services/apiClient';
import axiosInstance from '../../services/axiosInstance';

export const handleNoteSubmit = async (
  leadId: string | undefined,
  submitNotes: string[],
) => {
  const notesApiClient = new NotesClient(API_BASE_URL, axiosInstance);

  try {
    if (leadId && submitNotes && submitNotes.length > 0) {
      await Promise.all(
        submitNotes.map((note) => {
          let notePayload: NotesDTO = {
            leadId: leadId,
            text: note,
          };
          notesApiClient.createNotes(notePayload);
        }),
      );
    }
  } catch (error) {
    console.error('Error submitting notes:', error);
  }
};
